import { Link } from 'react-router-dom';

export default function BannerAd({ banner }) {
  if (!banner) return null;
  return (
    <Link to={banner.buttonLink} aria-label={banner.buttonName}
      className="relative mx-auto my-4 block w-full max-w-[1100px] overflow-hidden rounded-xl bg-slate-100 shadow-[0_6px_20px_rgba(0,0,0,0.06)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sky-600">
      <picture>
        {banner.mobileImage && <source media="(max-width: 639px)" srcSet={banner.mobileImage}
          width={banner.mobileWidth} height={banner.mobileHeight} />}
        <img src={banner.image} alt={banner.alt || banner.buttonName}
          width={banner.width} height={banner.height}
          loading="lazy" decoding="async" className="block h-auto w-full" />
      </picture>
    </Link>
  );
}
